import { getFirstTwoLetters } from '~/shared/lib/getFirstTwoLetters';
import { Typography } from '~/shared/ui/Typography/Typography';

import { Root } from './Logo.ui';

export const Logo = ({ name }: { name: string }) => (
  <Root>
    <Typography.H4>{getFirstTwoLetters(name).toUpperCase()}</Typography.H4>
  </Root>
);
